import { CloseOutlined } from "@mui/icons-material";
import {
    Button,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    IconButton,
    Radio,
    RadioGroup,
    TextField,
    Typography,
} from "@mui/material";
import { blue } from "@mui/material/colors";
import { useState } from "react";
import { apiGatewayAxiosInstance } from "../../utils/axios";

function HandleChangeBillingType({ open, handleClose, currentData, getMasterBillingDetails, setOperationStatus}) {
    const [billingType, setBillingType] = useState(currentData.billingPaymentType);
    const [currentBalance, setCurrentBalance] = useState(currentData.currentBalance || 0);
    const [capCheck, setCapCheck] = useState(currentData.capCheck || false);
    const [maxBalanceLimit, setMaxBalanceLimit] = useState(currentData.maxBalanceLimit || 0);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const onChangeRadio = (name, e) => {
        const value = e.target.value;
        if (name === "billingPaymentType") {
            setBillingType(value);
            if (value === "Postpaid") {
                setCurrentBalance(0);
                setCapCheck(false);
                setMaxBalanceLimit(0);
            } else {
                setCapCheck(false);
                setMaxBalanceLimit(0);
            }
        }
    };

    const handleChange = e => {
        const { name, value } = e.target;

        if (value < 0 || value === "0") {
            setError(true);
            return;
        }

        setError(false);
        if (name === "currentBalance") {
            setCurrentBalance(value);
        }

        if (name === "maxBalanceLimit") {
            setMaxBalanceLimit(value);
        }

        if (name === "capCheck") {
            setCapCheck(e.target.checked);
        }
    };

    const handleBlur = name => {
        if (!name) return;

        let error = {};

        if (name === "currentBalance" && currentBalance <= 0) {
            error[name] = "Balance must be greater than 0";
        }

        if (name === "maxBalanceLimit" && maxBalanceLimit <= 0) {
            error[name] = "Max Balance Limit must be greater than 0";
        }

        setErrors(prev => ({ ...prev, ...error }));
    };

    const handleBillingType = async ({ billingType, currentBalance, capCheck, maxBalanceLimit }) => {
        try {
            setLoading(true);
            const updatedBillingData = {
                ...currentData,
                billingPaymentType: billingType,
                currentBalance: currentBalance,
                capCheck: capCheck,
                maxBalanceLimit: maxBalanceLimit,
            };
            const response = await apiGatewayAxiosInstance.post("/billing_management/current-billing/change-billing-type", updatedBillingData);
            setOperationStatus({
                message: "Billing Type Changed Successfully.",
                success: true,
                failed: false,
            });
            getMasterBillingDetails();
            handleClose();
            setLoading(false);
            return response;
        } catch (error) {
            console.error("Error updating balance:", error);
            setLoading(false);
            throw error;
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} aria-labelledby="filter-dialog-title" maxWidth="xs" fullWidth>
            <DialogTitle
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Typography variant="h5">Change Billing Type</Typography>
                <IconButton onClick={handleClose}>
                    <CloseOutlined />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid>
                    <Typography variant="subtitle2">Billing Type:</Typography>
                    <FormControl sx={{ display: "flex", color: "grey" }}>
                        <RadioGroup
                            aria-labelledby="billing-type-radio-buttons-group"
                            value={billingType}
                            onChange={e => onChangeRadio("billingPaymentType", e)}
                            sx={{ display: "flex", flexDirection: "row", gap: "50px" }}
                        >
                            <FormControlLabel
                                value="Prepaid"
                                control={
                                    <Radio
                                        checked={billingType === "Prepaid"}
                                        color="primary"
                                        sx={{
                                            color: blue[800],
                                            "&.Mui-checked": {
                                                color: blue[600],
                                            },
                                        }}
                                        size="small"
                                    />
                                }
                                label={<Typography variant="subtitle2">Prepaid</Typography>}
                            />
                            <FormControlLabel
                                value="Postpaid"
                                control={
                                    <Radio
                                        checked={billingType === "Postpaid"}
                                        sx={{
                                            color: blue[800],
                                            "&.Mui-checked": {
                                                color: blue[600],
                                            },
                                        }}
                                        size="small"
                                    />
                                }
                                label={<Typography variant="subtitle2">Postpaid</Typography>}
                            />
                        </RadioGroup>
                    </FormControl>

                    {billingType !== currentData.billingPaymentType && (
                        <>
                            {billingType === "Prepaid" ? (
                                <Grid className="d-flex" gap={3} style={{ width: "49%" }}>
                                    <TextField
                                        disabled={false}
                                        type="number"
                                        inputProps={{
                                            step: "any",
                                        }}
                                        onWheel={e => e.target.blur()}
                                        name="currentBalance"
                                        style={{ width: "100%" }}
                                        className="field-spacing"
                                        label={
                                            <span>
                                                Add Balance (INR) <span style={{ color: "red" }}>*</span>
                                            </span>
                                        }
                                        variant="outlined"
                                        value={currentBalance}
                                        onChange={handleChange}
                                        onBlur={() => handleBlur("currentBalance")}
                                        error={Boolean(errors.currentBalance || error)}
                                        helperText={errors.currentBalance || (error && "Balance cannot be negative or zero")}
                                    />
                                </Grid>
                            ) : (
                                <Grid minHeight={"100%"} display={"flex"} flexDirection={"column"} alignItems={"start"}>
                                    {/* <Typography variant="body1" color={"gray"} sx={{ maxHeight: "35px", fontWeight: "300px" }}>
                                Currently your Usage Limit is <b>Unlimited. </b>
                                <br />
                                If you want to set Maximum Usage Limit, please enable Cap Check &nbsp;{" "}
                            </Typography> */}
                                    <FormControlLabel
                                        sx={{ mt: 5 }}
                                        control={<Checkbox checked={capCheck} onChange={handleChange} name="capCheck" size={"small"} />}
                                        label="Cap Check"
                                    />
                                    {billingType === "Postpaid" && capCheck && (
                                        <Grid display={"flex"} flexDirection={"column"}>
                                            <TextField
                                                fullWidth
                                                style={{ width: "100%" }}
                                                type="number"
                                                inputProps={{
                                                    step: "any",
                                                }}
                                                onWheel={e => e.target.blur()}
                                                name="maxBalanceLimit"
                                                value={maxBalanceLimit}
                                                className="field-spacing"
                                                label={
                                                    <span>
                                                        Balance Limit (INR) <span style={{ color: "red" }}>*</span>
                                                    </span>
                                                }
                                                variant="outlined"
                                                onChange={handleChange}
                                                onBlur={() => handleBlur("maxBalanceLimit")}
                                                error={Boolean(errors.maxBalanceLimit) || error}
                                                helperText={errors.maxBalanceLimit || (error && "Max Balance Limit cannot be negative or zero")}
                                            />
                                        </Grid>
                                    )}
                                </Grid>
                            )}
                        </>
                    )}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="error">
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleBillingType({ billingType, currentBalance, capCheck, maxBalanceLimit })}
                    disabled={error || loading || billingType === currentData.billingPaymentType || maxBalanceLimit > 100000000}
                    startIcon={loading ? <CircularProgress size={24} color="inherit" /> : null}
                >
                    {loading ? "Submitting..." : "Submit"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default HandleChangeBillingType;
